import { Injectable } from '@angular/core';

@Injectable()
export class BoxxImageUtils {
  constructor() {}

  getImgFileSize(imageUri: string): Promise<number> {
    return null;
    // return new Promise((resolve, reject) => {
    //   if (imageUri.startsWith('data:image')) {
    //     const contentWithoutMime = imageUri.split(',')[1];
    //     const sizeInBytes = window.atob(contentWithoutMime).length;
    //     return resolve(sizeInBytes);
    //   }

    //   this.file
    //     .resolveLocalFilesystemUrl(imageUri)
    //     .then((fileEntry) => {
    //       fileEntry.getMetadata(
    //         (fileObj) => {
    //           const size = fileObj.size;
    //           resolve(size);
    //         },
    //         (e) => {
    //           console.error(
    //             '**** getImgFileSize() -> fileEntry.getMetadata()',
    //             e
    //           );
    //           reject(e);
    //         }
    //       );
    //     })
    //     .catch((e) => {
    //       console.error(
    //         '**** getImgFileSize() -> file.resolveLocalFilesystemUrl()',
    //         e
    //       );
    //       reject(e);
    //     });
    // });
  }

  getImgDimensions(imageUri: any): Promise<{ width: number; height: number }> {
    // imageUri = normalizeUrl(imageUri);
    return new Promise((resolve, reject) => {
      let img = new Image();

      img.onload = (_) => {
        resolve({ width: img.width, height: img.height });
        img = null;
      };

      img.onerror = (e) => {
        reject(e);
        img = null;
      };

      img.src = imageUri;
    });
  }

  getImgBase64Dimensions(
    data: string
  ): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      let img = new Image();

      img.onload = (_) => {
        resolve({ width: img.width, height: img.height });
        img = null;
      };

      img.onerror = (e) => {
        reject(e);
        img = null;
      };

      img.src = data;
    });
  }

  imgDataUriToBase64(
    imageUri: string,
    outputFormat: string = 'image/jpeg'
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!imageUri) {
        return reject('Image URI must not be null/empty');
      }
      if (!outputFormat) {
        return reject('Image output format must not be null/empty');
      }

      let img = new Image();
      img.crossOrigin = 'Anonymous';

      img.onload = () => {
        let c = document.createElement('canvas') as HTMLCanvasElement;
        const ctx = c.getContext('2d');
        c.width = img.width;
        c.height = img.height;
        ctx.drawImage(img, 0, 0);
        const dataURL = c.toDataURL(outputFormat);
        c = null;
        resolve(dataURL);
        img = null;
      };

      img.onerror = (e) => {
        console.error('*** imgDataUriToBase64 ERROR:', e);

        reject(e);
        img = null;
      };

      imageUri = imageUri.replace('unsafe:', '');

      img.src = (window as any).Ionic.WebView.convertFileSrc(imageUri);
    });
  }

  imgBase64ToBlob(data: string) {
    return new Promise((resolve, reject) => {
      const contentWithoutMime = data.split(',')[1];
      resolve(window.atob(contentWithoutMime));
    });
  }

  resizeBase64Image(
    data: string,
    config: {
      width: number;
      height: number;
      outputFormat: 'png' | 'jpeg';
    }
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.crossOrigin = 'Anonymous';

      let canvas = document.createElement('canvas') as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');

      img.onload = () => {
        const outputHeight = img.height * (config.width / img.width);
        canvas.width = config.width;
        canvas.height = outputHeight;

        ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          0,
          0,
          config.width,
          outputHeight
        );

        const dataURL = canvas.toDataURL('image/' + config.outputFormat);
        canvas = null;
        resolve(dataURL);
        img = null;
      };

      img.onerror = (e) => {
        console.error('*** imgDataUriToBase64 ERROR:', e);

        reject(e);
        img = null;
      };

      img.src = data;
    });
  }
}
